import React, { Component } from 'react';
import { RegisterLiterals } from '../../literals/account/RegisterLiterals';
import { getLiteralsForCulture } from '../../literals/Literals';
import { AppProps } from '../AppState';

export class Registered extends Component<AppProps> {
  constructor(props: any)
  {
      super(props);
  }

  render () {
    var literals = getLiteralsForCulture(RegisterLiterals, this.props.appState.currentCulture) as any;
    
    return (
      <div>
          <section className="fit theme-dark-gray">
              <div className="row">
                  <div className="form-group col-md-offset-2 col-md-10">
                      <h2>{literals.registerLabel}</h2>

                      <p>{literals.sentLabel}</p>
                  </div>
              </div>
          </section>
      </div>
    );
  }
}
